module.exports = __webpack_public_path__ + "static/media/spinner.9725b84e.gif";